import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { adminNotificationActions } from './slice';
import capabilities from './capabilities';

export const ApiNotificationsGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminNotificationActions.startLoading());
    }

    await gestopAPI
        .post('admin/notifications/list', { filters, orderBy, groupBy, page, limit }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(adminNotificationActions.setList(response?.data?.list));
                    dispatch(adminNotificationActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(adminNotificationActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminNotificationActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminNotificationActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiNotificationsCountCollection = async ({
    filters = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('admin/notifications/count', { filters }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiNotificationsMarkAsReadCollection = async ({
    ids,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminNotificationActions.startLoading());
    }

    await gestopAPI
        .post('admin/notifications/markasread', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(adminNotificationActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(adminNotificationActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminNotificationActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminNotificationActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiNotificationsDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminNotificationActions.startLoading());
    }

    await gestopAPI
        .post('admin/notifications/delete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(adminNotificationActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(adminNotificationActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminNotificationActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminNotificationActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiNotificationsDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminNotificationActions.startLoading());
    }

    await gestopAPI
        .delete(`admin/notifications/${id}`, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(adminNotificationActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(adminNotificationActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminNotificationActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminNotificationActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
